<template>
  <div class="signup-page" :class="{ dark: theme === 'dark' }">
    <div class="reg-shell">
      <TopBar :theme="theme" @toggle-theme="toggleTheme" @go-login="goLogin" />

      <main class="reg-main" :class="{ 'is-done': done }">
        <HeroPanel v-if="!done" :data="data" />

        <section class="reg-card" :class="{ 'is-done': done }">
          <Stepper
            v-if="!done"
            :idx="idx"
            :total="stepsCount"
            :max-reached="maxReached"
            @go-to="goTo"
          />

          <StepDone v-if="done" :data="data" />

          <div v-else class="step-canvas" :key="idx">
            <StepHeader :idx="idx" :total="stepsCount" />
            <component
              :is="currentStepComponent"
              :data="data"
              :errors="errors"
              @update="update"
            />
          </div>

          <footer v-if="!done" class="step-footer">
            <button type="button" class="btn-ghost" :disabled="idx === 0 || submitting" @click="back">
              <LtIcon name="arrow-right" :size="18" />
              חזרה
            </button>

            <button v-if="skipAvailable" type="button" class="btn-text" :disabled="submitting" @click="next">
              דלגו על שלב זה
            </button>

            <button type="button" class="btn-primary" :disabled="submitting" @click="next">
              {{ primaryLabel }}
              <LtIcon name="arrow-left" :size="18" />
            </button>
          </footer>
        </section>
      </main>
    </div>
  </div>
</template>

<script>
import LtIcon from '../components/signup/LtIcon.vue';
import { STEPS, freshFormState, validateStep, buildSignupFormData } from '../components/signup/data.js';
import TopBar from '../components/signup/TopBar.vue';
import Stepper from '../components/signup/Stepper.vue';
import HeroPanel from '../components/signup/HeroPanel.vue';
import StepHeader from '../components/signup/StepHeader.vue';
import StepIdentity from '../components/signup/StepIdentity.vue';
import StepGenres from '../components/signup/StepGenres.vue';
import StepSocials from '../components/signup/StepSocials.vue';
import StepContacts from '../components/signup/StepContacts.vue';
import StepDone from '../components/signup/StepDone.vue';

import '../components/signup/signup.scss';

export default {
  name: 'SignupPage',
  components: {
    LtIcon, TopBar, Stepper, HeroPanel, StepHeader,
    StepIdentity, StepGenres, StepSocials, StepContacts, StepDone,
  },
  data() {
    return {
      data: freshFormState(),
      idx: 0,
      maxReached: 0,
      errors: {},
      done: false,
      theme: 'light',
      submitting: false,
    };
  },
  computed: {
    stepsCount() { return STEPS.length; },
    skipAvailable() { return this.idx === 2 || this.idx === 3; },
    primaryLabel() {
      return this.idx === this.stepsCount - 1 ? 'סיום והצטרפות' : 'המשך';
    },
    currentStepComponent() {
      return ['StepIdentity', 'StepGenres', 'StepSocials', 'StepContacts'][this.idx];
    },
  },
  methods: {
    update(patch) {
      this.data = { ...this.data, ...patch };
    },
    next() {
      const errs = validateStep(this.idx, this.data);
      if (Object.keys(errs).length) {
        this.errors = errs;
        return;
      }
      this.errors = {};

      if (this.idx === 0) {
        this.checkEmailAndAdvance();
        return;
      }

      if (this.idx === this.stepsCount - 1) {
        this.submitSignup();
        return;
      }

      this.advance();
    },
    checkEmailAndAdvance() {
      this.submitting = true;
      this.api(
        { action: 'signup/check_email', data: { email: this.data.email.trim() } },
        (res) => {
          this.submitting = false;
          const result = res && res.data ? res.data : res;
          if (typeof result === 'object' && result.available === true) {
            this.advance();
          } else if (typeof result === 'object' && result.available === false) {
            this.errors = { email: 'כתובת המייל כבר נמצאת בשימוש' };
          } else {
            this.alert('שגיאה בבדיקת המייל');
          }
        },
        () => {
          this.submitting = false;
          this.alert('שגיאה בבדיקת המייל');
        }
      );
    },
    submitSignup() {
      this.submitting = true;
      const formData = buildSignupFormData(this.data);
      this.api(
        { action: 'signup/artist', data: formData },
        (res) => {
          this.submitting = false;
          const result = res && res.data ? res.data : res;
          if (result && result.success) {
            this.done = true;
            window.scrollTo({ top: 0, behavior: 'smooth' });
          } else {
            this.alert((result && result.error) || 'שגיאה בהרשמה. נסו שוב.');
          }
        },
        () => {
          this.submitting = false;
          this.alert('שגיאה בהרשמה. נסו שוב.');
        }
      );
    },
    advance() {
      const nx = this.idx + 1;
      this.idx = nx;
      this.maxReached = Math.max(this.maxReached, nx);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    back() {
      if (this.idx > 0) {
        this.idx -= 1;
        this.errors = {};
      }
    },
    goTo(i) {
      this.idx = i;
      this.errors = {};
    },
    toggleTheme() {
      this.theme = this.theme === 'dark' ? 'light' : 'dark';
    },
    goLogin() {
      this.goto('/login');
    },
  },
}
</script>
